/**
 * Add CSS selector prefix
 */
if (typeof ap !== 'function') {
    ap = function(domElem, prefix) {
        return (prefix || '.') + domElem;
    }
}

var SelectionDropdown = function(domElement) {
    this.domElement = domElement;
    this.selectedOptionTitleClass = 'selected-option-title';
    this.optionClass = 'selection-option';
    this.optionTitleClass = 'option-title';
    this.selectedOptionClass = 'option-selected';
    this.selectedOption = null;
    this.onApply = null;

    this.selectOption = function(event) {
        if (event.target.classList.contains(this.optionClass) || event.target.classList.contains(this.optionTitleClass)) {
            var optionElement = event.target;
            if (event.target.classList.contains(this.optionTitleClass)) {
                optionElement = event.target.parentElement;
            }

            var oldOption = this.domElement.querySelector(ap(this.selectedOptionClass));
            if (oldOption) {
                oldOption.classList.remove(this.selectedOptionClass);
            }
            optionElement.classList.add(this.selectedOptionClass);
            this.selectedOption = optionElement.getAttribute('data-option');
            var title = this.domElement.querySelector(ap(this.selectedOptionTitleClass));
            title.innerHTML = optionElement.querySelector(ap(this.optionTitleClass)).innerHTML;
            if (this.onApply) {
                this.onApply();
            }
        }
    }

    this.bindEvents = function() {
        var optionElements = this.domElement.querySelectorAll(ap(this.optionClass));

        for (var i = 0; i < optionElements.length; i++) {
            optionElements[i].addEventListener('click', this.selectOption.bind(this));
        }
    }

    this.init = function() {
        this.bindEvents();
        var initialSelection = this.domElement.querySelector(ap(this.selectedOptionClass));
        if (initialSelection) {
            this.selectedOption = initialSelection.getAttribute('data-option');
            var title = this.domElement.querySelector(ap(this.selectedOptionTitleClass));
            title.innerHTML = initialSelection.querySelector(ap(this.optionTitleClass)).innerHTML;
        }
    }
}

if (document.querySelector('.job-order')) {
    var orderSelection = new SelectionDropdown(document.querySelector('.job-order'));
    orderSelection.init();
    jobsListingManager.desktopOrderingSelection = orderSelection;
    orderSelection.onApply = jobsListingManager.refreshResults.bind(jobsListingManager);
}
if (document.querySelector('.job-order-mobile')) {
    var mobileOrderSelection = new SelectionDropdown(document.querySelector('.job-order-mobile'));
    mobileOrderSelection.init();
    jobsListingManager.mobileOrderingSelection = mobileOrderSelection;
    mobileOrderSelection.onApply = () => {jobsListingManager.refreshResults('mobile')};
}
